import styled, {ThemeProps} from 'styled-components';

import {Theme} from './../../../../theme/types';
import {Column, Row} from './../../common/Layouts/Layouts';

export const WrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  padding-top: ${props.theme.spacing.base};
  padding-bottom: ${props.theme.spacing.base};
`,
);

export const ContentWrapperDiv = styled(Row)(
  (props: ThemeProps<Theme>) => `
  justify-content: center;
  align-items: center;
`,
);

export const LeftDoubleSkipStyles = styled.span(
  (props: ThemeProps<Theme>) => `
color: ${props.theme.colors.goBrand.blue};
padding-right: ${props.theme.spacing.base};
font-size: ${props.theme.font.large.font18};
cursor: pointer;
`,
);

export const LeftSkipStyles = styled.span(
  (props: ThemeProps<Theme>) => `
color: ${props.theme.colors.goBrand.blue};
font-size: ${props.theme.font.large.font18};
padding-right: ${props.theme.spacing.base};
cursor: pointer;
`,
);

export const RightSkipStyles = styled.span(
  (props: ThemeProps<Theme>) => `
color: ${props.theme.colors.goBrand.blue};
font-size: ${props.theme.font.large.font18};
padding-left: ${props.theme.spacing.base};
cursor: pointer;
`,
);

export const RightDoubleSkipStyles = styled.span(
  (props: ThemeProps<Theme>) => `
color: ${props.theme.colors.goBrand.blue};
font-size: ${props.theme.font.large.font18};
padding-left: ${props.theme.spacing.base};
cursor: pointer;
`,
);

export const ImageItemWrapperStyle = styled.span(
  (props: ThemeProps<Theme>) => `
  cursor: pointer;
  display: inline-flex;
  line-height: 1;
`,
);

export const ImageItemStyle = styled.img(
  (props: ThemeProps<Theme>) => `
  display: inline-block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  width: 12rem;
  height: 6.7rem;
`,
);

export const ImageGalleryUl = styled.ul`
  width: 105rem;
  align-items: center;
  overflow: auto;
  flex-direction: row;
  display: flex;
  > li {
    width: 120px;
    height: 70px;
    margin-right: 13px;
    flex-direction: row;
    &.active {
      border: 2px solid #fff;
      width: 124px;
      height: 74px;
    }
  }
`;

export const PaginationUl = styled.ul(
  (props: ThemeProps<Theme>) => `
  display: flex;
  flex-direction: row;
  >li{
      display:flex;
      cursor: pointer;
      padding:${props.theme.spacing.small.s3} ${props.theme.spacing.small.s7} ${props.theme.spacing.small.s3} ${props.theme.spacing.small.s7};
      align-items: center;
      color: ${props.theme.colors.goBrand.blue};
      border: 0.1rem solid ${props.theme.colors.grey.lineGrey};
      background-color: white;
      border-radius: 0.2rem;
      margin-right: ${props.theme.spacing.base};
      font-size: ${props.theme.font.large.font16};
      a {
        color: ${props.theme.colors.goBrand.blue};
      }
    &.active{
      font-weight:bold;
      background-color: ${props.theme.colors.goBrand.blue};
      border-radius: 0.2rem;
      color: white;
      a{
        color: white
      }
    }
  }
`,
);
